module.exports = __webpack_public_path__ + "img/Chengdu.6c18d941.jpg";